<template>
  <div class="flex size-full flex-col">
    <!-- IMAGE -->
    <div class="relative bg-gray-200">
      <AppImage
        v-if="slide.image"
        :src="slide.image"
        loading="eager"
        class="
          min-h-120 select-none object-contain
          md:h-[75vh]
        "
        :class="{
          'w-full': slide.image.width > slide.image.height,
          'mx-auto w-auto': slide.image.width < slide.image.height,
        }"
      />

      <div
        class="
          group absolute inset-0 bg-white/10 opacity-0 transition-opacity
          hover:pointer-events-auto hover:opacity-100
        "
      >
        <button
          :aria-label="$t('open_slider_full_screen')"
          type="button"
          class="
            absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 p-10
          "
          @click="$emit('open-slider-full-screen')"
        >
          <IconMagnifyingGlass
            class="
              size-10 text-white transition-transform
              hover:scale-125
            "
          />
        </button>
      </div>
    </div>

    <!-- TEXT -->
    <div
      class="
        -mx-px -mt-px flex grow flex-col justify-between bg-gray-500 px-4 pb-10
        pt-5 text-white
        md:px-10 md:pb-14 md:pt-8
      "
    >
      <div>
        <!-- Title -->
        <h3
          v-if="slide.heading"
          class="
            mb-3 whitespace-pre-wrap text-sm font-light
            md:max-w-3/4
          "
        >
          {{ slide.heading }}
        </h3>

        <!-- Text -->
        <div
          class="
            wysiwyg-only-lists line-clamp-6 text-lg font-semibold
            md:text-xl
          "
          v-html="slide.text"
        />
      </div>

      <!-- Links -->
      <div
        v-if="slide.links"
        class="
          my-6 flex flex-wrap gap-x-3
          md:mb-2
        "
      >
        <template v-for="item in slide.links">
          <AppButton
            v-if="item.link"
            :key="item.id"
            :to="item.link"
            class="hover-focus:bg-white/90"
            variant="primary"
          >
            {{ item.link_text }}
          </AppButton>
        </template>
      </div>
      <Copyright
        class="
          absolute bottom-4 left-4 !text-left
          md:left-10
        "
        :copyright="slide.copyright"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps ({
  data: {
    type: Object,
    required: true,
  },
})

const slide = computed(() => {
  if (props.data.content_source.value === 'linked') {
    return props.data.entry
  }
  return props.data
})

defineEmits(['open-slider-full-screen'])
</script>
